import { render, staticRenderFns } from "./UiInputRadio.vue?vue&type=template&id=3cbf3569&"
import script from "./UiInputRadio.vue?vue&type=script&lang=js&"
export * from "./UiInputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports